import './EmailTo.scss';

const EmailTo = ({ email, children }) => {

    return (
        <a href={`mailto:${email}`} className='button outline secondary'>{children}</a>
    );
}

export default EmailTo;